import React from 'react';

import { Stack, Text, createStyles } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface ModalTitleProps {
  title: string;
  lineCount: number;
}

const useStyles = createStyles(() => ({
  metadataText: {
    fontSize: '13px',
    color: 'rgba(55, 53, 47, 0.5)',
    margin: '0',
    padding: '0',
    fontWeight: 'normal',
    letterSpacing: '0.01em'
  }
}));

export function ModalTitle({ title, lineCount }: ModalTitleProps) {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack spacing={4}>
      <Text size="lg" weight={600} truncate w={700}>
        {title}
      </Text>
      <Text className={classes.metadataText}>
        {lineCount > 0
          ? t('RESOURCE_VIEWER_WRAPPER.LINES_COUNT', { count: lineCount })
          : t('RESOURCE_VIEWER_WRAPPER.LINES_COUNT', { count: 0 })}
      </Text>
    </Stack>
  );
}
